<template>
  <div class="">
    <div class="mb-3">
      <a class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="GoToDeposit(null, false)" title="افزودن قرارداد جدید">
        <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
      </a>
    </div>
    <BnpGrid v-if="$store.state.renderComponent" :hasRowNum="true" :propsColumn="Column" :SumList="['Amount', 'UnAmount']" :propsRows="DepositList" :action="true">


      <template slot="action-slot" slot-scope="props">
        <a v-if="props.props.TblComboIdGrp40 == 1789 && props.props.IsReceipt == false && $IsAccess('btnReceipt')" href="javascript:;" class="mr-2 badge" @click="ShowModal(props.props)" title="وصول چک"
          ><h6><span class="fad fa-money-check text-secondary hover-info"></span></h6
        ></a>
        <a v-if="props.props.TblComboIdGrp40 == 1789 && props.props.IsReceipt == true && $IsAccess('btnReceipt')" href="javascript:;" class="mr-2 badge" disabled title="چکــ وصول شده است"
          ><h6><span class="fad fa-money-check text-success"></span></h6
        ></a>
        <a href="javascript:;" class="mr-2 badge" @click="OnDetailDeposit(props.props)" data-title="جزئیات">
          <h5><span class="fad fa-info-circle hover-info"></span></h5>
        </a>
        <span class="mr-3 Pointer" @click="GoToDeposit(props.props, true)" title="عودت مبلــــغ"><i class="fas fa-dash mt-2 text-danger"></i></span>

        <a href="javascript:;" v-if="$store.state.JalaliDate == props.props.DateInsert || $session.get('UserInfo').tblGrpId == 1 || $session.get('UserInfo').tblUserId==205245" class="mr-2 badge" @click="OnDelete(props.props)" title="حذف"
          ><h6><span class="fas fa-trash-alt text-secondary hover-danger"></span></h6
        ></a>
      </template>
      <template slot="Amount" slot-scope="props">
        <span>{{ $Comma3ragham(Math.floor(props.props.Amount)) }}</span>
      </template>
      <template slot="UnAmount" slot-scope="props">
        <span class="text-warning">{{ $Comma3ragham(Math.floor(props.props.UnAmount)) }}</span>
      </template>
    </BnpGrid>
    <b-modal size="xl" centered id="modal-Detail">
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-danger" @click="close()">
                <span aria-hidden="true">&times;</span>
                </b-button>
                <h5>جزئـــیات </h5>
            </template>

            <template #default>
                <div dir="rtl">
                  <div class="col-md-3 col-12">
                        <small id="LblSerialId"> تاریخ وصول چک</small>
                        <date-picker color="dimgray" input-class="required form-control text-center" v-model="DateDepositCheck" clearable :editable="true"  placeholder=" تاریخ وصول چک "></date-picker>
                    </div>                  
                </div>
                </template>
            <template #modal-footer="{ cancel }">
                <b-button id="CancelCopy" size="sm" variant="danger"  @click="cancel()"> بستن </b-button>
                <b-button id="submit" size="sm" variant="dark" @click="ReceiptCheck()" >  تایید  </b-button>
            </template>
        </b-modal>

        <modal v-if="$store.state.Modal && MODAL" :InheritanceTheme="true" :IsFooter="false" :Size="'Sm'">
            <template v-slot:body>
              <div class="px-5 mt-3 text-center">
                <h4 class="text-danger">از وصول این چک اطمینان دارید ؟</h4>
                <span>در صورت اطمینان تاریخ وصول را انتخاب و دکمه تایید را انتخاب کنید</span>
              </div>
               <div class="px-5 mt-4 text-center" dir="rtl">
                  <small id="LblSerialId"> تاریخ وصول چک</small>
                  <date-picker color="dimgray" input-class="required form-control text-center" v-model="DateDepositCheck" clearable :editable="true"  placeholder=" تاریخ وصول چک "></date-picker>
                  <!-- <b-button id="CancelCopy" size="sm" variant="danger" class="m-2" @click="$store.state.Modal=false"> بستن </b-button> -->
                  <!-- <b-button id="submit" size="sm" variant="success-light" class=""  >  تایید  </b-button> -->
                  <button class="btn btn-success m-2 w-50" @click="ReceiptCheck();"> تایید</button>
               </div>
            </template>
            
        </modal>

  </div>
</template>
<script>
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Modal from '../../../Modal/Modal.vue'


export default {
  data() {
    return {
      MODAL:false,
      Column: [
        { id: 2416, name: 'TblComboIdGrp29Name', visibility: true, label: 'حساب واریزی' },
        { id: 2416, name: 'Amount', visibility: true, label: 'مبلغ واریزی' },
        { id: 2416, name: 'UnAmount', visibility: true, label: 'مبلغ عودت داده شده' },
        { id: 2416, name: 'Date', visibility: true, label: ' تاریخ واریز' },
        { id: 2416, name: 'TrackingCode', visibility: true, label: 'شماره پیگیری ' },
        { id: 2416, name: 'Des', visibility: true, label: 'توضیحات' },
        { id: 2416, name: 'TblComboIdGrp40Name', visibility: true, label: 'نوع واریزی' },
      ],
      Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
      DataAxiosDelete: {
        ArryfildValue: '',
        Method: 'Delete',
        Action: 'Deposit',
        Token: this.$session.get('Token'),
      },
      DataCopy:{},
      DateDepositCheck:''
    }
  },
  props: ['DepositList', 'CustomerId'],
  components: { BnpGrid , Modal,datePicker:VuePersianDatetimePicker },
  methods: {
    OnDelete(data) {
      this.$store.state.OldDataForLog = JSON.stringify(data)
      this.DataAxiosDelete.ArryfildValue = { id: data.Id }
      this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet).then((result) => {
        if (result == true) {
          this.$emit('Inserted', {
            done: 'OK',
          })
        }
      })
    },
    OnDetailDeposit(row) {
      let DataAxios_DetailDeposit = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Deposit/DetailDeposit/' + row.Id,
        Token: this.$session.get('Token'),
      }
      this.$PostData(DataAxios_DetailDeposit)
        .then((data) => {
          this.$emit('DetailDeposit', data)
        })
        .finally(() => {
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })
        })
    },
    ShowModal(row){
      // this.$bvModal.show('modal-Detail');
      this.$store.state.Modal=true
      this.MODAL=true
      this.DataCopy=row
    },
    ReceiptCheck() {

      let DataAxios_SetIsReceipt = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Deposit/SetIsReceipt',
        Token: this.$session.get('Token'),
      }
      DataAxios_SetIsReceipt.ArryfildValue = { tblDepositId: this.DataCopy.Id , DateDeposit:this.DateDepositCheck }
      this.$PostData(DataAxios_SetIsReceipt).then((data) => {
        this.$emit('Inserted', {
          done: 'OK',
        })
        if (this.DataCopy.IsReceipt == false) {
          this.$toasted.success('وضعیت چک به حالت وصــــول  درآمد', {
            duration: 2000,
          })
          this.$store.state.Modal=false
          this.MODAL=false
        } else {
          this.$toasted.success('وضعیت چک به حالت وصول نشده  درآمد', {
            duration: 2000,
          })
        }
      })
    },
    GoToDeposit(row, IsOdat) {
      if (IsOdat) {
        this.$router.push({ name: 'Deposit', params: { TblCustomerId: this.CustomerId, DepositInfo: row } })
      } else {
        this.$router.push({ name: 'Deposit', params: { TblCustomerId: this.CustomerId } })
      }
    },
    UnDeposit(row) {
      this.UnDepositRow = row
      this.$bvModal.show('modal-UnDeposit')
    },
  },
  mounted() {
    this.$GetAccessUser()
  },
}
</script>
<style scoped></style>
